import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Constants from './constants';
import ConstantsDetail from './constants-detail';
import ConstantsUpdate from './constants-update';
import ConstantsDeleteDialog from './constants-delete-dialog';

const ConstantsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Constants />} />
    <Route path="new" element={<ConstantsUpdate />} />
    <Route path=":id">
      <Route index element={<ConstantsDetail />} />
      <Route path="edit" element={<ConstantsUpdate />} />
      <Route path="delete" element={<ConstantsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ConstantsRoutes;
